import axios from "axios";
import { GOPEOPLE_API_URL } from "../config";
import { getValidGoPeopleToken } from "../auth/authTokenManagerGoPeople";
import {
  getAuthInfosFromCookie,
  updateAuthCookie,
  logout,
} from "../utils";
import { refreshAccessToken } from "./auth";

let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach(({ resolve, reject }) => {
    if (error) {
      reject(error);
    } else {
      resolve(token);
    }
  });
  failedQueue = [];
};

const goPeopleAxios = axios.create({
  baseURL: GOPEOPLE_API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});


goPeopleAxios.interceptors.request.use(
  async (config) => {
    const token = await getValidGoPeopleToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);


goPeopleAxios.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (
      error.response?.status !== 401 ||
      !originalRequest ||
      originalRequest._retry
    ) {
      return Promise.reject(error);
    }

    originalRequest._retry = true;

    const authInfos = getAuthInfosFromCookie();
    const refreshToken = authInfos?.refreshToken;

    if (!refreshToken) {
      logout(false);
      window.location.href = "/";
      return Promise.reject(error);
    }

    if (isRefreshing) {
      return new Promise((resolve, reject) => {
        failedQueue.push({ resolve, reject });
      }).then((token) => {
        originalRequest.headers.Authorization = `Bearer ${token}`;
        return goPeopleAxios(originalRequest);
      });
    }

    isRefreshing = true;

    try {
      const tokens = await refreshAccessToken(refreshToken);

      // updateAuthCookie({
      //   ...authInfos,
      //   jwtToken: tokens.accessToken,
      //   refreshToken: tokens.refreshToken,
      //   createdAt: Math.floor(Date.now() / 1000),
      // });

      processQueue(null, tokens.accessToken);

      originalRequest.headers.Authorization = `Bearer ${tokens.accessToken}`;

      return goPeopleAxios(originalRequest);
    } catch (refreshError) {
      processQueue(refreshError, null);

      logout(false);
      window.location.href = "/";

      return Promise.reject(refreshError);
    } finally {
      isRefreshing = false;
    }
  }
);

export default goPeopleAxios;
